import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { isEqual } from 'lodash'

// Styles
import './orderinspection.scss'

// Actions
import {
  getOrderInspection,
  saveOrderInspection,
  getNextDeliveryTimes,
  getDeliveryTimes,
  GetDeliveryChange,
  getPickupTimes,
  getOrder,
  setOrder,
  saveOrder,
  StopLockOrder,
  isFileReady,
  uploadFileToOrder,
  deleteFileFromOrder,
  GetAssessmentItemsInOrderInspection,
  setLastVisitedOrderId
} from '../../../actions/orders'
import { triggerPopup } from '../../../actions/backdrop'
import { getOrderData } from '../../../actions/assign'
import { invoiceHistory, getInvoiceStatus, approveOrderInvoice } from '../../../actions/invoicing'
import { setPageTitle } from '../../../actions/common'
import { getStandardNotes } from '../../../actions/notes'
import { getInsuranceCompanies } from '../../../actions/insurancecompanies'

// Components
import Header from '../../../shared/components/Header'
import Portal from '../../../shared/components/Portal'
import NotesModal from '../../../shared/modals/NotesModal'
import AssignBox from '../../NewWorkscreen/AssignBox'
import Confirm from '../../../shared/components/Confirm'
import ResendText from '../../../shared/components/ActionMenu/OrderActions/ResendText'
import store from '../../../store'
import Invoice from '../../../shared/components/Invoice'

// Modals
import DeliveryDateChangeModal from '../../../shared/modals/DeliveryDateChangeModal'
import OtherPriceModal from '../../../shared/modals/OtherPriceModal'
import CreateEstimationModal from '../../../shared/modals/CreateEstimationModal'

// Utils
import { formatDate } from '../../../utils/time'
import { formatCurrency, reverseFormatCurrency } from '../../../utils/currency'
import { makeOrderPageTitleObject } from '../../../utils/order'
import { shouldHaveArrow } from '../../../utils/router'
import { hasAccess, hasSubscriptionPermission, hasAccessToAssign } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'

// New Components
import ExternalDeviation from './ExternalDeviation'
import Assessment from './Assessment'
import AssignWorker from './AssignWorker'
import OrderStop from './OrderStop'
import OtherComments from './OtherComments'
import CustomInspection from './CustomInspection'
import MissingParts from './MissingParts'
import Color from './Color'
import Deadline from './Deadline'
import ProcessComments from './ProcessComments'
import Files from './Files'
import Claim from './Claim'
import InspectionHeader from './InspectionHeader'
import BodyshopBooking from './BodyshopBooking'
import OtherDamage from './OtherDamage'

// Elements
import Row from '../../../shared/elements/row'
import Col from '../../../shared/elements/col'
import Inline from '../../../shared/elements/inline'
import Icon from '../../../shared/elements/icon'
import BackButton from '../../../shared/elements/backButton'
import CloseButton from '../../../shared/elements/closeButton'

import { OrderDepartmentIcons } from '../../../shared/elements/icons'
import ForsiCreateReport from '../../../shared/components/ForsiCreateReport'

class OrderInspection extends Component {

  constructor (props) {
    super(props)
    this.state = {
      assessmentItems: null,
      assessmentItemsBodyshop: null,
      inspection: {},
      note: {
        modal: false,
        data: {}
      },
      DeadlineTimes: null,
      BodyshopDeadlineTimes: null,
      Deadline: null,
      BodyshopDeadline: null,
      dimensions: {
        width: 0,
        height: 0
      },
      order: {},
      steps: [],
      StepAssignments: [],
      stopMessage: '',
      showAssign: false,
      confirmFileDelete: {
        confirm: false,
        file: null
      },
      upload: {
        loading: false,
        errors: []
      },
      createEstimationPopup: {
        show: false
      },
      deliveryChangePopup: {
        show: false,
        showOnSave: false,
        oldDate: '',
        oldProductionDate: '',
        newDate: '',
        reason: 1,
        comment: '',
        confirmed: false
      },
      ShowDeliveryChangePopup: false,
      otherPopup: {
        open: false,
        other: {
          Title: '',
          Price: '',
          Environment: '',
          Description: ''
        }
      },
      showPopup: false,
      lastHistory: {
        FoundHistory: false
      },
      isLoadingLastHistory: false,
      confirmApproveAssesment: {
        open: false
      },
      hasPaintWork: true,
      hasBodyWork: true,
      isLoading: false,
      standardNotes: [],
      InsuranceCompanies: []
    }

    this.onBlur = this.onBlur.bind(this)
    this.showNoteModal = this.showNoteModal.bind(this)
    this.onNoteSuccess = this.onNoteSuccess.bind(this)
    this.headerButtonsRight = this.headerButtonsRight.bind(this)
    this.onAssignUsers = this.onAssignUsers.bind(this)
    this.getAssignOrderData = this.getAssignOrderData.bind(this)
    this.renderFileArea = this.renderFileArea.bind(this)
    this.updateImages = this.updateImages.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
    this.renderDeliveryDatePopup = this.renderDeliveryDatePopup.bind(this)
    this.showDeliveryDatePopup = this.showDeliveryDatePopup.bind(this)
    this.updateFromDeliveryTime = this.updateFromDeliveryTime.bind(this)
    this.fnListener = window.debounce(this.updateDimensions, 250)
    this.PriceChange = this.PriceChange.bind(this)
    this.onConfirmApprove = this.onConfirmApprove.bind(this)
    this.toggleInspection = this.toggleInspection.bind(this)
    this.stopLockOrder = this.stopLockOrder.bind(this)
    this.onChangeTime = this.onChangeTime.bind(this)
    this.onDeadlineChange = this.onDeadlineChange.bind(this)
    this.renderAssesment = this.renderAssesment.bind(this)
    this.renderOtherDamage = this.renderOtherDamage.bind(this)
    this.renderExternalDeviation = this.renderExternalDeviation.bind(this)
    this.renderAssignWorker = this.renderAssignWorker.bind(this)
    this.renderOrderStop = this.renderOrderStop.bind(this)
    this.renderInvoice = this.renderInvoice.bind(this)
    this.onUpdateOrder = this.onUpdateOrder.bind(this)
    this.getAssessmentItems = this.getAssessmentItems.bind(this)
    this.onStandardNoteUpdate = this.onStandardNoteUpdate.bind(this)
    this.togglePopup = this.togglePopup.bind(this)
    this.onCreateEstimationSave = this.onCreateEstimationSave.bind(this)
  }
  stopLockOrder (data) {
    this.props.StopLockOrder(data).then((res) => {
      // window.toastr.success(translation('13403'), translation('13424'))
      this.loadOrder()
      // this.props.onClose()
    }, () => {
      window.toastr.error(translation('13404'), translation('216'))
    })
  }
  toggleInspection (name) {
    // Get type
    let type = (this.state.inspection[name] === null || typeof this.state.inspection[name] === 'undefined') ? 0 : (typeof this.state.inspection[name] === 'boolean') ? 1 : 2

    const canToggle = () => {
      if (this.state.order.OrderType !== 1) return true
      if (this.state.order.LastUpdatedType !== 1) return true
      let inspection = { ...this.state.inspection }
      return (name !== 'AfterEvaluation' && name !== 'BodyshopAfterEvaluation') || type === 1 && inspection[name] || type === 2 && inspection[name].Checked
    }
    const save = () => {
      switch (type) {
        case 1:
          inspection[name] = !inspection[name]
          break
        case 2:
          inspection[name].Checked = !inspection[name].Checked
          inspection[name].AssessmentSelection = inspection[name].Checked ? 2 : 0
          break
      }
      this.saveOrderInspection(inspection).then(() => {
        if (name === 'AfterEvaluation' || name === 'BodyshopAfterEvaluation') {
          if (inspection[name].Checked) {
            this.props.approveOrderInvoice(this.state.order.Id, false).then((res) => {
              console.log('order approved for invoice')
            }).catch(() => { })
          } else {
            this.props.approveOrderInvoice(this.state.order.Id, true).then((res) => {
              console.log('order disapproved for invoice')
            }).catch(() => { })
          }
        }
      })
    }
    let inspection = { ...this.state.inspection }
    if (canToggle()) {
      if ((name !== 'AfterEvaluation' && name !== 'BodyshopAfterEvaluation') || this.state.inspection[name].Checked === true) {
        // if ((this.state.order.OrderType !== 1) || (this.state.order.OrderType === 1 && this.state.inspection.AfterEvaluation.Checked === true)) {
        save()
      } else {
        this.setState({
          isLoadingLastHistory: true
        }, () => {
          this.props.invoiceHistory(this.state.order.Id).then((res) => {
            this.setState({
              lastHistory: res.data,
              isLoadingLastHistory: false
            }, () => {
              if (this.state.lastHistory.FoundHistory && this.state.inspection[name].Checked === false) {
                this.setState({
                  confirmApproveAssesment: {
                    open: !this.state.confirmApproveAssesment.open
                  }
                })
              } else if (!this.state.lastHistory.FoundHistory) {
                save()
              }
            })
          })
        })
      }
    } else {
      this.setState({
        showPopup: true
      })
    }
  }
  componentDidMount () {
    this._mounted = true
    // setTimeout(() => {
    //   console.log('orderInspection didMount', hasSubscriptionPermission(this.props.auth, 20), isLAKexperten(this.props.auth), this.props.auth)
    //   if (hasSubscriptionPermission(this.props.auth, 20) && isLAKexperten(this.props.auth)) {
    //     this.props.GetAssessmentItemsInOrderInspection(this.props.params.orderID, 0).then((res) => {
    //       this.setState({
    //         assessmentItems: res.data
    //       }, () => console.log('assessmentItems after set state ', this.state.assessmentItems))
    //     }, () => {
    //     })
    //     this.props.GetAssessmentItemsInOrderInspection(this.props.params.orderID, 1).then((res) => {
    //       this.setState({
    //         assessmentItemsBodyshop: res.data
    //       })
    //     }, () => {
    //     })
    //   }
    // }, 500)
    this.getAssessmentItems()

    this.getOrderInspection()
    window.addEventListener('resize', this.fnListener)
    this.updateDimensions()
    this.loadOrder()
    this.getAssignOrderData()
    this.checkFileTimer = setInterval(this.updateImages, 3000)
    this.setState({
      confirmApproveAssesment: {
        open: false
      },
      hasPaintWork: this.props.auth.departmentType !== 2 || this.props.auth.user.Department !== 1,
      hasBodyWork: this.props.auth.departmentType !== 2 || this.props.auth.user.Department !== 0
    })

    this.props.getStandardNotes().then((res) => {
      this.onStandardNoteUpdate(res.data)
    })

    this.props.getInsuranceCompanies().then(res => {
      this.setState({ InsuranceCompanies: res.data.Item2 })
    })
  }
  componentWillUnmount () {
    this._mounted = false
    window.removeEventListener('resize', this.fnListener)
    clearInterval(this.checkFileTimer)
  }

  componentWillReceiveProps (nextProps) {
    if (!isEqual(this.props.auth, nextProps.auth) && this.state.assessmentItems === null && this.state.assessmentItemsBodyshop === null && !this.state.isLoading) {
      this.getAssessmentItems()
    }
  }

  onStandardNoteUpdate (notes) {
    this.setState({
      standardNotes: notes
    })
  }

  getAssessmentItems () {
    if (hasSubscriptionPermission(this.props.auth, 20) && hasAccessToAssign(this.props.auth)) {
      this.setState({
        isLoading: true
      }, () => {
        const getAssesments = () => this.props.GetAssessmentItemsInOrderInspection(this.props.params.orderID, 0).then((res) => {
          this.setState({
            assessmentItems: res.data
          })
        }, () => {
        })
        const getBodyAssesments = () => this.props.GetAssessmentItemsInOrderInspection(this.props.params.orderID, 1).then((res) => {
          this.setState({
            assessmentItemsBodyshop: res.data
          })
        }, () => {
        })
        Promise.all([ getAssesments(), getBodyAssesments() ]).then(() => {
          this.setState({
            isLoading: false
          })
        })
      })
    }
  }

  loadOrder () {
    let orderId = this.props.params.orderID
    this.props.getOrder(orderId).then((res) => {
      if (/\/orders\/\d{6,}\/orderinspection/.test(this.props.router.location.pathname)) {
        // Only change if still on '/orders/xxxxxx/orderinspection'
        this.props.setPageTitle(makeOrderPageTitleObject(res.data))
      }

      this.setState({
        order: res.data,
        otherPopup: {
          open: false,
          other: {
            Title: res.data.OtherTitle,
            Price: res.data.Price,
            Environment: res.data.Environment,
            Description: res.data.Description
          }
        }
      })
    })
  }

  saveOrder () {
    if (this.state.order === undefined || this.state.order === null || this.state.order.Id === 0) return null

    let data = this.state.order
    return this.props.saveOrder(data).then((res) => {
      // window.toastr.success(translation('13403'), translation('13424'))
      return res
    }, () => {
      window.toastr.error(translation('13404'), translation('216'))
      return null
    })
  }

  updateImages () {
    if (Object.keys(this.state.order).length === 0) return null
    if (window.location.hostname === 'localhost') return null
    let files = [...this.state.order.OrderFiles]
    let order = { ...this.state.order }
    for (let i = 0; i < files.length; i++) {
      if (files[i].IsImage) {
        let img = files[i]
        if (img.IsFinishedLoading === false) {
          // Check with api if file is ready.
          this.props.isFileReady(img.OrderFileID).then((res) => {
            if (res.data.FileReady === true) {
              let append = '?preventCache=' + Math.random() * 10
              img.IsFinishedLoading = true
              img.ThumbURL = res.data.ThumbURL + append
              img.FileURL = res.data.FileURL + append
              // files[i] = img
              order.OrderFiles[i] = img
              this.setState({
                order: {
                  ...this.state.order,
                  OrderFiles: order.OrderFiles
                }
              })
            }
          })
        }
      }
    }
  }

  getAssignOrderData (activeEmployees) {
    if (!hasSubscriptionPermission(this.props.auth, 20) || !hasAccessToAssign(this.props.auth)) return
    if (hasAccess([6], this.props.auth.user.UserType)) { // wp don't need assign data
      return
    }

    // Find order ids
    let orderId = this.props.params.orderID
    let orderIds = []
    orderIds.push(orderId)
    // Get assign order data
    this.props.getOrderData({
      OrderIds: orderIds,
      UserIds: activeEmployees || this.props.activeEmployees
    }).then((res) => {
      this.setState({
        StepAssignments: res.data.StepAssignments
      })
    }, () => {
      window.toastr.error(translation('1922'), translation('216'))
    })
  }

  onAssignUsers () {
    this.refs.AssignBox.getWrappedInstance().getAssignEmployees()
  }

  updateDimensions () {
    let w = window
    let d = document
    let documentElement = d.documentElement
    let body = d.getElementsByTagName('body')[0]

    let width = w.innerWidth || documentElement.clientWidth || body.clientWidth
    let height = w.innerHeight || documentElement.clientHeight || body.clientHeight

    this.setState({
      dimensions: {
        width: width,
        height: height
      }
    })
  }

  dimensionShow (dimensions) {
    let show = false
    dimensions.map((val, key) => {
      if (!show) {
        let higherThan = val[0]
        let lessThan = val[1]
        let width = this.state.dimensions.width
        if (width > higherThan && width < lessThan) show = true
      }
    })
    return show
  }
  getOrderInspection () {
    this.props.getOrderInspection(this.props.params.orderID).then((res) => {
      if (typeof res.data.Claim !== 'undefined' && res.data.Claim !== null) {
        res.data.Claim.ComplaintPrice = formatCurrency(res.data.Claim.ComplaintPrice)
      }
      let deadline = null
      let bodyDeadline = null
      let deadlineTimes = null
      let bodyDeadlineTimes = null

      let showDeliveryChangePopup = false
      if (res.data.Deadline !== null) {
        deadline = {
          Pickup: res.data.Deadline.Pickup,
          Delivery: res.data.Deadline.Delivery,
          ProductionDate: res.data.Deadline.ProductionDate,
          Checked: res.data.Deadline.Checked
        }
        deadlineTimes = {
          PickupTimes: res.data.Deadline.PickupTimes,
          DeliveryTimes: res.data.Deadline.DeliveryTimes,
          ProductionTimes: res.data.Deadline.ProductionTimes
        }
        showDeliveryChangePopup = res.data.Deadline.ShowDeliveryChangePopup
      }
      if (res.data.BodyshopDeadline !== null) {
        bodyDeadline = {
          Pickup: res.data.BodyshopDeadline.Pickup,
          Delivery: res.data.BodyshopDeadline.Delivery,
          ProductionDate: res.data.BodyshopDeadline.ProductionDate,
          Checked: res.data.BodyshopDeadline.Checked
        }
        bodyDeadlineTimes = {
          PickupTimes: res.data.BodyshopDeadline.PickupTimes,
          DeliveryTimes: res.data.BodyshopDeadline.DeliveryTimes,
          ProductionTimes: res.data.BodyshopDeadline.ProductionTimes
        }
        showDeliveryChangePopup = res.data.Deadline.ShowDeliveryChangePopup
      }
      this.setState({
        inspection: res.data,
        Deadline: deadline,
        DeadlineTimes: deadlineTimes,
        BodyshopDeadline: bodyDeadline,
        BodyshopDeadlineTimes: bodyDeadlineTimes,
        ShowDeliveryChangePopup: showDeliveryChangePopup
      }, () => {
        if (res.data.MissingParts !== null && res.data.MissingParts.Note && this.state.inspection.MissingParts.Note === null) {
          let inspection = res.data
          inspection.MissingParts.MissingParts = true
          this.saveOrderInspection(inspection)
        }
      })
    }, () => {
      window.toastr.error(translation('15004'), translation('960'))
      console.log('Error getting order inspection')
    })
  }

  saveOrderInspection (inspection, skipCheck) {
    let inspec = { ...inspection }
    if (typeof skipCheck === 'undefined') {
      if (typeof inspec.Claim !== 'undefined' && inspec.Claim !== null) {
        inspec.Claim.ComplaintPrice = parseFloat(reverseFormatCurrency(inspec.Claim.ComplaintPrice))
      }
    }
    if (this.state.ShowDeliveryChangePopup && this.state.deliveryChangePopup.showOnSave === true && this.state.deliveryChangePopup.confirmed !== true && !this.state.deliveryChangePopup.show) {
      this.showDeliveryDatePopup()
      return false
    }

    return this.props.saveOrderInspection(inspection).then((res) => {
      // Toastr
      if (typeof res.data.Claim !== 'undefined' && res.data.Claim !== null) {
        res.data.Claim.ComplaintPrice = formatCurrency(res.data.Claim.ComplaintPrice)
      }
      let deadline = null
      let bodyDeadline = null
      let deadlineTimes = null
      let bodyDeadlineTimes = null
      if (res.data.Deadline !== null) {
        deadline = {
          Pickup: res.data.Deadline.Pickup,
          Delivery: res.data.Deadline.Delivery,
          ProductionDate: res.data.Deadline.ProductionDate,
          Checked: res.data.Deadline.Checked
        }
        deadlineTimes = {
          PickupTimes: res.data.Deadline.PickupTimes,
          DeliveryTimes: res.data.Deadline.DeliveryTimes,
          ProductionTimes: res.data.Deadline.ProductionTimes
        }
      }
      if (res.data.BodyshopDeadline !== null) {
        bodyDeadline = {
          Pickup: res.data.BodyshopDeadline.Pickup,
          Delivery: res.data.BodyshopDeadline.Delivery,
          ProductionDate: res.data.BodyshopDeadline.ProductionDate,
          Checked: res.data.BodyshopDeadline.Checked
        }
        bodyDeadlineTimes = {
          PickupTimes: res.data.BodyshopDeadline.PickupTimes,
          DeliveryTimes: res.data.BodyshopDeadline.DeliveryTimes,
          ProductionTimes: res.data.BodyshopDeadline.ProductionTimes
        }
      }
      this.setState({
        inspection: res.data,
        Deadline: deadline,
        DeadlineTimes: deadlineTimes,
        BodyshopDeadline: bodyDeadline,
        BodyshopDeadlineTimes: bodyDeadlineTimes
      })
      // Update Invoice component
      this.props.getInvoiceStatus(this.state.order.Id).then((result) => {
        let order = { ...this.state.order }
        order.ReadyForInvoice = result.data.ReadyForInvoice
        order.ReadyForInvoiceByWP = result.data.ReadyForInvoiceByWP
        order.IsMarkInvoiced = result.data.IsMarkInvoiced
        order.IsMarkInvoicedByWP = result.data.IsMarkInvoicedByWP
        order.IsInvoiced = result.data.IsInvoiced
        order.IsInvoicedByWP = result.data.IsInvoicedByWP
        order.InvoiceStatusIsResat = result.data.InvoiceStatusIsResat

        this.setState({
          order: order,
          inspection: res.data,
          Deadline: deadline,
          DeadlineTimes: deadlineTimes
        }, () => {
          // window.toastr.success(translation('1911'), translation('13424'))
        })
        return res
      })
    }, (err) => {
      if (err.response) {
        if (err.response.data !== undefined && err.response.data.Errors !== undefined && err.response.data.Errors.length === 1) {
          let error = err.response.data.Errors[0]
          let text = translation(error.DictionaryKey)
          if (error.Parameters.length === 1) {
            text = text.replace('[WorkProvider]', error.Parameters[0])
          }
          window.toastr.error(text, translation('216'))
        } else if (err.response.status === 403) {
          window.toastr.error(translation('1794'), translation('216'))
        } else {
          window.toastr.error(translation('910'), translation('216'))
        }
      }
      this.getOrderInspection()
      return err
    })
  }

  onChange (obj, e) {
    e.persist()
    let value = e.target.value
    if (e.target.type === 'checkbox') value = e.target.checked
    this.setState({
      inspection: {
        ...this.state.inspection,
        [obj]: {
          ...this.state.inspection[obj],
          [e.target.name]: value
        }
      }
    }, () => {
      if (['Color', 'BodyshopColor'].includes(obj)) { // Set same color for both
        let propName = 'Color'
        if (obj === 'Color') propName = 'BodyshopColor'
        this.setState({
          inspection: {
            ...this.state.inspection,
            [propName]: {
              ...this.state.inspection[propName],
              [e.target.name]: value
            }
          }
        })
      }
      if (e.target.type === 'checkbox') {
        this.onBlur()
      }
    })
  }

  onBlur () {
    setTimeout(() => {
      this.saveOrderInspection(this.state.inspection)
    }, 0)
  }

  renderConfirmApproveDialog () {
    return (
      <div>
        <ResendText isLoadingLastHistory={this.state.isLoadingLastHistory} lastHistory={this.state.lastHistory} t={translation} store={store} assessment />
      </div>
    )
  }

  onPortalClose (type) {
    this.setState({
      [type]: {
        ...this.state[type],
        open: false
      }
    })
  }

  onConfirmApprove () {
    let inspection = { ...this.state.inspection }
    let name = this.props.auth.departmentType === 1 ? 'BodyshopAfterEvaluation' : 'AfterEvaluation'
    inspection[name].Checked = true
    this.saveOrderInspection(inspection).then(() => {
      this.onPortalClose('confirmApproveAssesment')
    }, () => {
    })
  }

  renderTitle (name, context) {
    // Get type
    let type = (this.state.inspection[name] === null || typeof this.state.inspection[name] === 'undefined') ? 0 : (typeof this.state.inspection[name] === 'boolean') ? 1 : 2
    // Image
    let image = 'Red_marking'
    switch (type) {
      case 1:
        if (this.state.inspection[name]) image = 'Green_chekmark'
        break
      case 2:
        if (this.state.inspection[name].Checked) image = 'Green_chekmark'
        break
    }
    const canToggle = () => {
      if (this.state.order.OrderType !== 1) return true
      if (this.state.order.LastUpdatedType !== 1) return true
      let inspection = { ...this.state.inspection }
      return name !== 'AfterEvaluation' || type === 1 && inspection[name] || type === 2 && inspection[name].Checked
    }
    // On Click
    const onChangeMarking = () => {
      const save = () => {
        switch (type) {
          case 1:
            inspection[name] = !inspection[name]
            break
          case 2:
            inspection[name].Checked = !inspection[name].Checked
            break
        }
        this.saveOrderInspection(inspection).then(() => {
        })
      }
      let inspection = { ...this.state.inspection }
      if (canToggle()) {
        if (name !== 'AfterEvaluation' || this.state.inspection.AfterEvaluation.Checked === true) {
          // if ((this.state.order.OrderType !== 1) || (this.state.order.OrderType === 1 && this.state.inspection.AfterEvaluation.Checked === true)) {
          save()
        } else {
          this.setState({
            isLoadingLastHistory: true
          }, () => {
            this.props.invoiceHistory(this.state.order.Id).then((res) => {
              this.setState({
                lastHistory: res.data,
                isLoadingLastHistory: false
              }, () => {
                if (this.state.lastHistory.FoundHistory && this.state.inspection.AfterEvaluation.Checked === false) {
                  this.setState({
                    confirmApproveAssesment: {
                      open: !this.state.confirmApproveAssesment.open
                    }
                  })
                } else if (!this.state.lastHistory.FoundHistory) {
                  save()
                }
              })
            })
          })
        }
      } else {
        this.setState({
          showPopup: true
        })
      }
    }
    // Return
    if (context !== '901') {
      return <div className='title' onClick={onChangeMarking}>{translation(context)}<img className='right' src={'/images/icons/' + image + '.png'} /></div>
    } else {
      return <div className='title' onClick={onChangeMarking}><img className='left large' src='/images/svgs/taksering/damage assessment.svg' />{translation(context)}<img className='right' src={'/images/icons/' + image + '.png'} /></div>
    }
  }

  renderMissingParts (isBodyshop) {
    if (this.state.inspection.MissingParts === null) return null
    const changeMissingPartStatus = (e) => {
      this.setState({
        inspection: {
          ...this.state.inspection,
          MissingParts: {
            ...this.state.inspection.MissingParts,
            MissingParts: e
          }
        }
      }, this.onBlur)
    }

    return <MissingParts standardNotes={this.state.standardNotes} onStandardNoteUpdate={this.onStandardNoteUpdate} onHeaderClick={this.toggleInspection} MissingParts={this.state.inspection.MissingParts} changeMissingPartStatus={changeMissingPartStatus.bind(this)} order={this.state.order} onNoteSuccess={this.onNoteSuccess} isBodyshop={isBodyshop} />
  }

  renderColor (isBodyshop) {
    if (isBodyshop && !this.state.order.HasAvailablePaintPartner) return null
    let propName = 'Color'
    if (isBodyshop) propName = 'BodyshopColor'
    let prop = this.state.inspection[propName]
    if (prop === null) return null
    return <Color order={this.state.order} onBlur={this.onBlur.bind(this)} onChange={this.onChange.bind(this)} color={prop} onHeaderClick={this.toggleInspection} isBodyshop={isBodyshop} />
  }

  onDeadlineChange (dateTime, name, isBodyshop) {
    let newDate = ''
    let newTime = ''
    let momentDate = moment(dateTime)
    let propName = 'Deadline'
    if (isBodyshop) propName = 'BodyshopDeadline'
    // momentDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    let inspection = { ...this.state.inspection }
    let oldDelivery = inspection[propName].Delivery
    let oldProduction = inspection[propName].ProductionDate
    switch (name) {
      case 'Pickup':
        newDate = momentDate.format('YYYY-MM-DD')
        newTime = momentDate.format('HH:mm')
        this.props.getPickupTimes(newDate, newTime, this.state.inspection.CustomerId).then((res) => {
          let AvailableTimes = res.data.AvailableTimes
          this.setState({
            [propName]: {
              ...this.state[propName],
              [name]: formatDate(momentDate)
            },
            DeadlineTimes: {
              ...this.state.DeadlineTimes,
              PickupTimes: AvailableTimes
            }
          })
        }, (err) => {
          // Toastr
          window.toastr.error(translation(err.response.data.DictionaryKey), translation('216'))
        })
        break
      case 'Delivery':
        newDate = momentDate.format('YYYY-MM-DD') + ' ' + momentDate.format('HH:mm:ss')
        this.props.getDeliveryTimes(newDate, undefined, this.props.order.Id).then((res) => {
          let AvailableTimes = res.data.AvailableDeliveryTimes
          let deliveryChanged = (moment(inspection[propName].Delivery) !== moment(newDate))
          this.setState({
            [propName]: {
              ...this.state[propName],
              [name]: formatDate(momentDate)
            },
            DeadlineTimes: {
              ...this.state.DeadlineTimes,
              DeliveryTimes: AvailableTimes
            },
            deliveryChangePopup: {
              ...this.state.deliveryChangePopup,
              confirmed: false,
              showOnSave: deliveryChanged,
              newDate: newDate,
              oldDate: oldDelivery,
              show: !isBodyshop // Always show for paint
            }
          })
        }, (err) => {
          // Toastr
          window.toastr.error(translation(err.response.data.DictionaryKey), translation('216'))
        })
        break
      case 'ProductionDate':
        newDate = momentDate.format('YYYY-MM-DD') + ' ' + momentDate.format('HH:mm:ss')
        this.props.getDeliveryTimes(newDate, undefined, this.props.order.Id).then((res) => {
          let AvailableTimes = res.data.AvailableDeliveryTimes
          let firstProductionTime = AvailableTimes[0]
          newDate = momentDate.format('YYYY-MM-DD') + ' ' + firstProductionTime + ':00'
          momentDate = moment(newDate)
          let deliveryChanged = (moment(inspection[propName].Delivery) <= moment(newDate))
          this.setState({
            [propName]: {
              ...this.state[propName],
              ProductionDate: newDate,
              ProductionTimes: AvailableTimes
            },
            DeadlineTimes: {
              ...this.state.DeadlineTimes,
              ProductionTimes: AvailableTimes
            },
            deliveryChangePopup: {
              ...this.state.deliveryChangePopup,
              confirmed: false,
              showOnSave: deliveryChanged,
              newDate: newDate,
              oldDate: oldDelivery,
              oldProductionDate: oldProduction
            }
          }, () => {
            inspection[propName].ProductionDate = newDate
          })
        }, (err) => {
          // Toastr
          window.toastr.error(translation(err.response.data.DictionaryKey), translation('216'))
        })
        break
    }
    setTimeout(() => {
      if (this.state.deliveryChangePopup.show) return

      inspection[propName].PickupTimes = this.state.DeadlineTimes.PickupTimes
      inspection[propName].DeliveryTimes = this.state.DeadlineTimes.DeliveryTimes
      inspection[propName].ProductionTimes = this.state.DeadlineTimes.ProductionTimes
      if (name === 'ProductionDate') {
        inspection[propName].DateChangeReason = 1
      } else if (name === 'Delivery') {
        inspection[propName].DateChangeReason = 2
        inspection[propName][name] = formatDate(momentDate)
      } else {
        inspection[propName].DateChangeReason = null
        inspection[propName][name] = formatDate(momentDate)
      }
      this.setState({
        DateChangeReason: inspection[propName].DateChangeReason,
        inspection: inspection
      })
      this.saveOrderInspection(inspection)
    }, 100)
  }
  onChangeTime (value, name, isBodyshop) {
    let splitted = value.split(':')
    let propName = 'Deadline'
    if (isBodyshop) propName = 'BodyshopDeadline'
    let dateVal = window.CustomDate(this.state[propName][name])
    let momentDate = moment(dateVal)
    momentDate.set({ hour: splitted[0], minute: splitted[1], second: 0, millisecond: 0 })
    // Save date
    let inspection = { ...this.state.inspection }
    inspection[propName][name] = formatDate(momentDate)
    inspection[propName].PickupTimes = this.state.DeadlineTimes.PickupTimes
    inspection[propName].DeliveryTimes = this.state.DeadlineTimes.DeliveryTimes
    inspection[propName].ProductionTimes = this.state.DeadlineTimes.ProductionTimes
    let deliveryChanged = false
    let oldDate = this.state[propName].Delivery
    let oldProduction = this.state[propName].ProductionDate
    let newDate = oldDate
    if (name === 'ProductionDate') {
      inspection[propName].DateChangeReason = 1
      deliveryChanged = (moment(oldDate) <= momentDate)
    } else if (name === 'Delivery') {
      inspection[propName].DateChangeReason = 2
      deliveryChanged = (moment(oldDate) !== momentDate)
    } else {
      inspection[propName].DateChangeReason = null
    }
    newDate = momentDate.format('YYYY-MM-DD') + ' ' + momentDate.format('HH:mm:ss')
    this.setState({
      deliveryChangePopup: {
        ...this.state.deliveryChangePopup,
        confirmed: false,
        showOnSave: deliveryChanged,
        newDate: newDate,
        oldDate: oldDate,
        oldProductionDate: oldProduction
      }
    }, () => {
      this.saveOrderInspection(inspection)
    })
  }

  renderDeadline (isBodyshop) {
    return <Deadline deadline={isBodyshop ? this.state.BodyshopDeadline : this.state.Deadline} deadlineTimes={isBodyshop ? this.state.BodyshopDeadlineTimes : this.state.DeadlineTimes} order={this.state.order} onHeaderClick={this.toggleInspection} onChangeTime={this.onChangeTime} onDeadlineChange={this.onDeadlineChange} isBodyshop={isBodyshop} />
  }
  renderBodyshopBooking () {
    let checked = false
    if (this.state.inspection.BodyshopBooking) {
      checked = this.state.inspection.BodyshopBooking.Checked
    }
    const onUpdateOrder = () => {
      this.loadOrder()
    }
    const onChange = (e) => {
      let name = e.target.name
      let value = e.target.value
      let inspection = { ...this.state.inspection }
      if (name === 'Transport') {
        inspection.BodyshopBooking[name] = value
      }
      if (name === 'LoosePartsType') {
        inspection.BodyshopBooking[name] = value === '1'
      }
      this.saveOrderInspection(inspection)
    }
    return <BodyshopBooking togglePopup={this.togglePopup.bind(this)} getInspection={this.getOrderInspection.bind(this)} checked={checked} bodyshopBooking={this.state.inspection.BodyshopBooking} onInputChange={onChange} deadline={this.state.Deadline} deadlineTimes={this.state.DeadlineTimes} order={this.state.order} onHeaderClick={this.toggleInspection} onChangeTime={this.onChangeTime} onDeadlineChange={this.onDeadlineChange} onUpdateOrder={onUpdateOrder.bind(this)} />
  }
  renderCustomInspections (isBodyshop) {
    if (!this.state.inspection.CustomInspections || this.state.inspection.CustomInspections.length === 0) return null
    const changeStatus1 = (key) => {
      let inspection = { ...this.state.inspection }
      inspection.CustomInspections[key].Checked = !inspection.CustomInspections[key].Checked
      this.saveOrderInspection(inspection)
    }
    const renderCustomInspection = (item, key) => {
      return <CustomInspection key={key} standardNotes={this.state.standardNotes} onStandardNoteUpdate={this.onStandardNoteUpdate} onNoteSuccess={this.onNoteSuccess} item={item} keyIndex={key} order={this.state.order} changeStatus={changeStatus1} isBodyshop={isBodyshop} />
    }
    // return (
    //   <div key={k} className='note bottom'>
    //     <strong>{note.UsersInitials}: {renderFullDate(note.NoteDate)}</strong>
    //     {note.Note}
    //   </div>
    // )
    // }
    // return (
    //   <div className='white__box' key={key}>
    //     <div className='title' onClick={changeStatus}><img className='right' src={'/images/icons/' + image + '.png'} />{item.Text}</div>
    //     <div className='notes'>
    //       {item.InspectionNotes.map(renderNote)}
    //     </div>
    //     <div className='form'>
    //       <button className='button full primary' onClick={openComment}><img src='/images/icons/circle_plus22.png' />{translation('149')}</button>
    //     </div>
    //   </div>
    // )
    // }
    return (
      this.state.inspection.CustomInspections.map(renderCustomInspection)
    )
  }

  renderCreateEstimationPopup () {
    if (!this.state.createEstimationPopup.show) return null
    let topMessage = [
      translation('13568')
    ]
    let returnOrder = true
    return (
      <CreateEstimationModal
        show={this.state.createEstimationPopup.show}
        topMessage={topMessage}
        id={this.state.order.Id}
        returnOrder={returnOrder}
        onClose={this.togglePopup.bind(this, 'createEstimationPopup', false)}
        onSave={this.onCreateEstimationSave}
      />
    )
  }

  onCreateEstimationSave (order) {
    if (typeof order !== 'undefined') {
      this.togglePopup('createEstimationPopup', false)
      this.onUpdateOrder(order)
    } else {
      this.saveSingleValue('IsEvaluation', true, () => {
        this.togglePopup('createEstimationPopup', false)
        this.onUpdateOrder(this.state.order)
      })
    }
  }

  togglePopup (prop, visible) {
    if (typeof visible !== 'boolean') {
      visible = !this.state[prop].show
    }
    if (!visible && prop === 'handleCarRentalPopup') {
      // After editing advanced car rentals in popup, reload order.
      this.onUpdateOrder()
    }
    this.setState({
      [prop]: {
        ...this.state[prop],
        show: visible
      }
    }, () => {
      this.props.triggerPopup(visible)
    })
  }

  onNoteSuccess () {
    this.getOrderInspection()
  }

  showNoteModal () {
    this.props.triggerPopup(!this.state.note.modal)
    this.setState({
      note: {
        ...this.state.note,
        data: {},
        modal: !this.state.note.modal
      }
    })
  }

  renderOtherComment (isBodyshop) {
    if (!hasSubscriptionPermission(this.props.auth, 10)) return null
    return (
      <OtherComments standardNotes={this.state.standardNotes} onStandardNoteUpdate={this.onStandardNoteUpdate} onNoteSuccess={this.onNoteSuccess} OrderNotes={this.state.inspection.OrderNotes} order={this.state.order} isBodyshop={isBodyshop} />
    )
  }

  renderProcessComment (isBodyshop) {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    let propName = 'ProcessComment'
    if (isBodyshop) propName = 'BodyshopProcessComment'
    const saveProcessComment = (processComment) => {
      let inspection = { ...this.state.inspection }
      inspection[propName] = processComment
      this.saveOrderInspection(inspection)
    }
    const onBlur = () => {
      setTimeout(() => {
        this.saveOrderInspection(this.state.inspection)
      }, 0)
    }
    const onChange = (e, key) => {
      e.persist()
      let inspection = { ...this.state.inspection }
      if (e.target.type === 'checkbox') {
        let name = e.target.name.split('_')[0]
        inspection[propName].ProcessComments[key][name] = e.target.checked
      } else {
        inspection[propName].ProcessComments[key].Text = e.target.value
      }
      this.setState({
        inspection: inspection
      }, () => {
        if (e.target.type === 'checkbox') {
          onBlur()
        }
      })
    }
    const deleteItem = (e, key) => {
      e.preventDefault()
      let inspection = { ...this.state.inspection }
      inspection[propName].ProcessComments[key].DeletedBy = this.props.auth.user.UserId || 0
      this.setState({
        inspection: inspection
      }, onBlur)
    }
    return <ProcessComments saveProcessComment={saveProcessComment} onBlur={onBlur} onChange={onChange} deleteItem={deleteItem} order={this.state.order} processComment={this.state.inspection[propName]} onHeaderClick={this.toggleInspection} isBodyshop={isBodyshop} />
  }
  renderAssesment (isBodyshop) {
    let propName = 'AfterEvaluation'
    if (isBodyshop) propName = 'BodyshopAfterEvaluation'
    const onChange = (e) => {
      let inspection = { ...this.state.inspection }
      inspection[propName].AssessmentSelection = Number(e.target.value)
      inspection[propName].Checked = Number(e.target.value) === 2
      this.setState({
        inspection: inspection
      }, () => {
        this.saveOrderInspection(this.state.inspection).then(() => {
          if (propName === 'AfterEvaluation' || propName === 'BodyshopAfterEvaluation') {
            if (inspection[propName].Checked) {
              this.props.approveOrderInvoice(this.state.order.Id, false).then((res) => {
                console.log('order approved for invoice')
              }).catch(() => { })
            } else {
              this.props.approveOrderInvoice(this.state.order.Id, true).then((res) => {
                console.log('order disapproved for invoice')
              }).catch(() => { })
            }
          }
        })
        // this.toggleInspection(propName)
      })
    }
    if (this.state.inspection[propName] === null) return null
    return <Assessment router={this.props.router} AfterEvaluation={this.state.inspection[propName]} onChange={onChange} order={this.state.order} onHeaderClick={this.toggleInspection} isBodyshop={isBodyshop} PriceChange={this.PriceChange} assessmentItems={isBodyshop ? this.state.assessmentItemsBodyshop : this.state.assessmentItems} />
  }
  renderOtherDamage () {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    if (this.state.inspection.OtherDamage === null) return null
    return <OtherDamage otherDamage={this.state.inspection.OtherDamage} order={this.state.order} onHeaderClick={this.toggleInspection} />
  }
  renderExternalDeviation (isBodyshop) {
    if (this.state.inspection.ExternalWork === null || this.state.order.OrderType === 4) return null
    if (!hasSubscriptionPermission(this.props.auth, 30)) return null
    return <ExternalDeviation ExternalWork={this.state.inspection.ExternalWork} order={this.state.order} onHeaderClick={this.toggleInspection} isBodyshop={isBodyshop} />
  }
  renderAssignWorker (isBodyshop) {
    if (!hasSubscriptionPermission(this.props.auth, 20) || !hasAccessToAssign(this.props.auth)) return null
    if (isBodyshop) return null
    return <AssignWorker router={this.props.router} order={this.state.order} getAssignOrderData={this.getAssignOrderData} StepAssignments={this.state.StepAssignments} isBodyshop={isBodyshop} />
  }
  renderOrderStop (isBodyshop) {
    if (this.state.order.IsReferredOut) return null
    return <OrderStop order={this.state.order} stopLockOrder={this.stopLockOrder} isBodyshop={isBodyshop} />
  }
  renderClaim (isBodyshop) {
    let propName = 'Claim'
    if (isBodyshop) propName = 'BodyshopClaim'
    const onBlur = (e) => {
      setTimeout(() => {
        this.saveOrderInspection(this.state.inspection)
      }, 0)
    }
    const onChange = (e) => {
      e.persist()
      let inspection = { ...this.state.inspection }

      if (isBodyshop) {
        inspection.Claim = null
      } else {
        inspection.BodyshopClaim = null
      }

      if (e.target.name === 'ComplaintPrice') {
        inspection[propName].ComplaintPrice = e.target.value
      } else {
        if (e.target.name === 'Payment') {
          inspection[propName].ComplaintPayer = (e.target.value === 'us') ? 1 : 0
        } else {
          inspection[propName].ComplaintOurRefNr = e.target.value
        }
      }
      this.setState({
        inspection: inspection
      }, () => {
        if (e.target.type === 'checkbox' || e.target.type === 'radio') {
          onBlur(e)
        }
      })
    }
    if (!this.state.inspection.Claim && !this.state.inspection.BodyshopClaim) return null
    return <Claim order={this.state.order} onChange={onChange} onBlur={onBlur} claim={this.state.inspection[propName]} shopName={this.state.inspection.ShopName} customerName={this.state.inspection.CustomerName} onHeaderClick={this.toggleInspection} isBodyshop={isBodyshop} />
  }

  updateFromDeliveryTime (data) {
    this.setState({
      inspection: {
        ...this.state.inspection,
        Deadline: {
          ...this.state.inspection.Deadline,
          DeliveryChangeReason: data.DeliveryChangeReason,
          DeliveryChangeComment: data.DeliveryChangeComment,
          Delivery: data.NewDate,
          CommentApplyToInvoice: data.CommentApplyToInvoice,
          CommentShowToCustomer: data.CommentShowToCustomer
        }
      },
      deliveryChangePopup: {
        ...this.state.deliveryChangePopup,
        confirmed: data.Confirmed
      }
    }, () => {
      if (data.Confirmed) { this.showDeliveryDatePopup(false) }
      let inspection = this.state.inspection
      this.saveOrderInspection(inspection, true)
    })
  }

  showDeliveryDatePopup (visible) {
    if (visible === undefined) {
      visible = !this.state.deliveryChangePopup.show
    }
    this.props.triggerPopup(visible)
    this.setState({
      deliveryChangePopup: {
        ...this.state.deliveryChangePopup,
        show: visible
      }
    })
  }

  renderDeliveryDatePopup () {
    if (!this.state.deliveryChangePopup.show) return null
    const onClose = () => {
      let visible = false
      this.props.triggerPopup(visible)
      this.setState({
        deliveryChangePopup: {
          ...this.state.deliveryChangePopup,
          show: visible
        },
        inspection: {
          ...this.state.inspection,
          Deadline: {
            ...this.state.inspection.Deadline,
            Delivery: this.state.deliveryChangePopup.oldDate,
            ProductionDate: this.state.deliveryChangePopup.oldProductionDate
          }
        },
        Deadline: {
          ...this.state.Deadline,
          Delivery: this.state.deliveryChangePopup.oldDate,
          ProductionDate: this.state.deliveryChangePopup.oldProductionDate
        }
      })
    }
    return (
      <DeliveryDateChangeModal
        show={this.state.deliveryChangePopup.show}
        onClose={onClose.bind(this)}
        onSave={this.updateFromDeliveryTime}
        oldDate={this.state.deliveryChangePopup.oldDate}
        newDate={this.state.deliveryChangePopup.newDate}
        clientName={this.state.order.CustomerName}
        shopName={this.state.order.ShopName}
        times={this.state.inspection.Deadline.DeliveryTimes} />
    )
  }

  headerButtonsRight () {
    const goBack = (type) => {
      if (/* shouldHaveArrow() && */ type === 'close') {
        let routeItem = window.LocalstorageStack.findFirst(['/workscreen', '/orders'])
        if (routeItem !== null) {
          if (routeItem.pathname === '/orders') {
            let orderId = this.props.routeParams.orderID
            this.props.setLastVisitedOrderId(orderId)
            this.props.router.replace({
              pathname: '/orders',
              query: {
                orderid: orderId
              }
            })
          } else {
            this.props.router.replace(routeItem.pathname)
          }
        } else {
          this.props.router.goBack()
        }
      } else {
        this.props.router.goBack()
      }
    }
    const renderArrowBack = () => {
      let topOfStack = window.LocalstorageStack.top()
      if (topOfStack && !shouldHaveArrow()) {
        return null
      }
      return <BackButton onClick={goBack.bind(this, 'back')} ariaText={translation('394')} />
    }
    return (
      <div>
        {renderArrowBack()}
        <CloseButton onClick={goBack.bind(this, 'close')} ariaText={translation('2060')} />
      </div>
    )
  }

  renderFileArea (isBodyshop) {
    return <Files order={this.state.order} upload={this.state.upload} loadOrder={this.loadOrder.bind(this)} isBodyshop={isBodyshop} />
  }

  PriceChange (isBodyshop) {
    let pat = '/1'
    if (isBodyshop) pat = '/bodyextent'
    if (this.state.order.OrderType === 4) {
      this.setState({
        otherPopup: {
          ...this.state.otherPopup,
          open: true
        }
      })
    } else {
      this.props.router.push('pricecalculation/' + this.state.order.Id + pat)
    }
  }

  onUpdateOrder (res) {
    if (typeof res === 'undefined' || typeof res === undefined) {
      // console.log('here???')
      this.props.getOrder(this.props.params.orderID)
    } else {
      this.props.setOrder(res)
      this.setState({ order: res })
      this.getOrderInspection()
    }
  }

  renderInvoice () {
    if (this.state.order === undefined) {
      console.log('OrderInspection: ORDER UNDEFINED!')
    }
    return (
      <Invoice invoiceOrder={this.state.order} updateOrder={this.onUpdateOrder} />
    )
  }

  renderForsiToken () {
    const { order, InsuranceCompanies } = this.state
    let forsiEnable = this.props.auth.permissions.ChainAssessmentSystem === 1 // Forsi is available for the company

    if (!forsiEnable) return null
    if (order.OrderType !== 1) return null

    return (
      <ForsiCreateReport order={order} forsi={InsuranceCompanies} />
    )
  }

  render () {
    if (this.state.inspection == null || !this.state.order.Id) return null
    if (!hasSubscriptionPermission(this.props.auth, 10)) return null
    if (Object.keys(this.state.inspection).length === 0) return null
    // let title = translation('13423')
    // if (typeof this.state.order.Id !== 'undefined') {
    //   title = makeOrderTitle(this.state.order, translation, enumtranslate, false, true)
    // }
    const onPortalClose = (type) => {
      this.setState({
        [type]: {
          ...this.state[type],
          open: false
        }
      })
    }

    const notConfirm = () => {
      this.setState({
        showPopup: false
      })
    }
    const confirm = () => {
      let inspection = { ...this.state.inspection }
      let name = this.props.auth.departmentType === 1 ? 'BodyshopAfterEvaluation' : 'AfterEvaluation'
      let type = (this.state.inspection[name] === null || typeof this.state.inspection[name] === 'undefined') ? 0 : (typeof this.state.inspection[name] === 'boolean') ? 1 : 2

      switch (type) {
        case 1:
          inspection[name] = !inspection[name]
          break
        case 2:
          inspection[name].Checked = !inspection[name].Checked
          break
      }
      this.saveOrderInspection(inspection)
      this.setState({
        showPopup: false
      })
    }
    const renderCommonItems = () => {
      if (this.props.auth.departmentType === 1) {
        if (this.dimensionShow([[0, 1056]])) {
          return (
            <Col key='1'>
              <div className='section__status'>
                {this.renderInvoice()}
                {this.renderForsiToken()}
              </div>
              {this.renderOrderStop(false)}
              {this.renderCustomInspections(false)}
              {this.renderOtherComment(false)}
              {this.renderFileArea(false)}
              {this.state.hasPaintWork && renderPaintItems()}
            </Col>
          )
        }
        if (this.state.hasPaintWork && this.dimensionShow([[0, 1401]])) {
          return (
            <Col key='1'>
              <div className='section__status'>
                {this.renderInvoice()}
                {this.renderForsiToken()}
              </div>
              {this.renderOrderStop(false)}
              {this.renderCustomInspections(false)}
              {this.renderOtherComment(false)}
              {this.renderFileArea(false)}
            </Col>
          )
        }
        return ([
          <Col key='1'>
            <div className='section__status'>
              {this.renderInvoice()}
              {this.renderForsiToken()}
            </div>
            {this.renderOrderStop(false)}
            {this.renderCustomInspections(false)}
            {this.renderOtherComment(false)}
          </Col>,
          <Col key='2'>
            {this.renderFileArea(false)}
          </Col>
        ])
      }
      if (this.props.auth.departmentType === 2) {
        // let classNames = 'col common'
        // if (columnsWhenShowBoth) {
        //   classNames = 'common'
        // }
        return (
          <Col>
            <div className='section__status'>
              {this.renderInvoice()}
            </div>
            {this.renderOrderStop(false)}
            {this.renderCustomInspections(false)}
            {this.renderOtherComment(false)}
            {this.renderFileArea(false)}
          </Col>
        )
      }
      if (this.dimensionShow([[0, 1056]])) {
        return ([
          <Col key='1'>
            {this.renderClaim(false)}
            <div className='section__status'>
              {this.renderInvoice()}
            </div>
            {this.renderAssesment(false)}
            {this.renderExternalDeviation(false)}
            {this.renderAssignWorker(false)}
            {this.renderOrderStop(false)}
            {this.renderMissingParts(false)}
            {this.renderColor(false)}
          </Col>,
          <Col key='2'>
            {this.renderDeadline(false)}
          </Col>
        ])
      }

      return ([
        <Col key='1'>
          {this.renderClaim(false)}
          <div className='section__status'>
            {this.renderInvoice()}
          </div>
          {this.renderAssesment(false)}
          {this.renderExternalDeviation(false)}
          {this.renderAssignWorker(false)}
          {this.renderOrderStop(false)}
        </Col>,
        <Col key='2'>
          {this.renderMissingParts(false)}
          {this.renderColor(false)}
          {this.renderDeadline(false)}
        </Col>
      ])
    }
    const getTitle = (type) => {
      if (!this.dimensionShow([[0, 1073]])) {
        return null
      }
      let title = translation('14779')
      let icon = OrderDepartmentIcons.Body
      if (type === 'paint') {
        title = translation('161')
        icon = OrderDepartmentIcons.Paint
      }
      return (
        <div className='orderDepartment'>
          <Inline block alignChildren={'center'}>
            <Icon icon={icon} />
            <h2>{title}</h2>
          </Inline>
        </div>
      )
    }
    const renderBodyItems = () => {
      if (this.props.auth.departmentType === 0) return null
      if (this.props.auth.departmentType === 1) {
        return (
          <Col>
            {getTitle('body')}
            {this.renderAssesment(true)}
            {this.renderOtherDamage()}
            {this.renderClaim(true)}
            {this.renderDeadline(true)}
            {this.renderAssignWorker(true)}
            {this.renderProcessComment(true)}
          </Col>
        )
      }
      return (
        <Col>
          {getTitle('body')}
          {this.renderAssesment(false)}
          {this.renderDeadline(true)}
          {this.renderAssignWorker(true)}
          {this.renderProcessComment(true)}
        </Col>
      )
    }
    const renderPaintItems = () => {
      if (this.props.auth.departmentType === 1) {
        if (this.props.hasPartner === false) return null

        if (this.dimensionShow([[0, 1056]])) {
          return ([
            getTitle('paint'),
            this.renderBodyshopBooking(),
            this.renderColor(true)
          ])
        }
        return (
          <Col>
            {getTitle('paint')}
            {this.renderBodyshopBooking()}
            {this.renderColor(true)}
          </Col>
        )
      }
      if (this.props.auth.departmentType === 2) {
        if (this.dimensionShow([[0, 1073]])) {
          // let classNames = 'col'
          // if (columnsWhenShowBoth) {
          //   classNames = ''
          // }
          return (
            <Col key='3'>
              {getTitle('paint')}
              {this.renderClaim(false)}
              {this.renderAssesment(false)}
              {this.renderOtherDamage()}
              {this.renderDeadline(false)}
              {this.renderAssignWorker(false)}
              {this.renderProcessComment(false)}
              {this.renderExternalDeviation(false)}
              {this.renderColor(false)}
              {this.renderMissingParts(false)}
            </Col>
          )
        }
        return ([
          <Col key='3'>
            {this.renderClaim(false)}
            {this.renderAssesment(false)}
            {this.renderOtherDamage()}
            {this.renderDeadline(false)}
            {this.renderAssignWorker(false)}
            {this.renderProcessComment(false)}
          </Col>,
          <Col key='4'>
            {this.renderExternalDeviation(false)}
            {this.renderColor(false)}
            {this.renderMissingParts(false)}
          </Col>
        ])
      }
      if (this.dimensionShow([[1376, 1377]])) {
        return ([
          <Col key='1'>
            {this.renderProcessComment(false)}
            {this.renderOtherComment(false)}
            {this.renderFileArea(false)}
          </Col>,
          <Col key='2'>
            {this.renderCustomInspections(false)}
          </Col>
        ])
      }

      return (
        <Col>
          {this.renderProcessComment(false)}
          {this.renderOtherComment(false)}
          {this.renderFileArea(false)}
          {this.renderCustomInspections(false)}
        </Col>
      )
    }
    /* const renderFirstColumn = () => {
      // let assessmentClass = 'assessmentItems2'
      // if (assessmentItems.AnyOnWorkcard && assessmentItems.AssessmentItemDetails.length) {
      //   assessmentClass = 'assessmentItems'
      // }
      return (
        <div>
          {renderCommonItems()}
          {this.state.hasPaintWork && renderPaintItems()}
        </div>
      )
    } */
    if (this.state.inspection == null) return null
    if (Object.keys(this.state.inspection).length === 0) return null
    // let Deviations
    // if (this.state.inspection.ExternalWork !== null) {
    //   Deviations = this.state.inspection.ExternalWork.Deviations
    // }

    const toggleBody = () => {
      this.setState({
        hasBodyWork: !this.state.hasBodyWork
      })
    }
    const togglePaint = () => {
      this.setState({
        hasPaintWork: !this.state.hasPaintWork
      })
    }

    const isOver1072 = !this.dimensionShow([[0, 1056]])
    const hasPaintWork = this.state.hasPaintWork && !(this.props.auth.departmentType === 1 && this.props.hasPartner === false)

    // Change 2nd link to pricecalc/4 to be controlled by ordertype
    return (
      <div className='orderinspection__screen' >
        <Header router={this.props.router} renderRight={this.headerButtonsRight}>
          <InspectionHeader hasBodyWork={this.state.hasBodyWork} hasPaintWork={hasPaintWork} toggleBody={toggleBody} togglePaint={togglePaint} key='131' />
        </Header>
        {this.state.showPopup === true && <Confirm
          t={translation}
          renderText={() => translation('14781')}
          confirm={confirm.bind(this)}
          notConfirm={notConfirm.bind(this)} />}
        <NotesModal
          show={this.state.note.modal}
          onClose={this.showNoteModal}
          note={this.state.note.data}
          onSuccess={this.onNoteSuccess}
          standardNotes={this.state.standardNotes}
          onStandardNoteUpdate={this.onStandardNoteUpdate}
          order={this.state.order} />
        {this.state.confirmApproveAssesment.open && (
          <Portal className='resendModal' onPortalClose={onPortalClose.bind(this, 'confirmApproveAssesment')}>
            <Confirm renderText={this.renderConfirmApproveDialog.bind(this)} confirm={this.onConfirmApprove} notConfirm={onPortalClose.bind(this, 'confirmApproveAssesment')} disabled={this.state.isLoadingLastHistory === true} />
          </Portal>
        )}
        <div className='orderinspection__screen--inner' key='13'>
          <Row>
            {renderCommonItems()}
            {this.state.hasBodyWork && renderBodyItems()}
            {(isOver1072 || this.props.auth.departmentType !== 1) && this.state.hasPaintWork && renderPaintItems()}
          </Row>
        </div>
        {this.renderDeliveryDatePopup()}
        {this.renderCreateEstimationPopup()}
        <div>
          {this.state.showAssign && <AssignBox ref='AssignBox' onEmployeeChange={this.getAssignOrderData} closeAssign={() => { this.setState({ showAssign: false }) }} />}
        </div>
        {
          (this.state.order.OrderType === 4) && (
            <OtherPriceModal
              type={1}
              show={this.state.otherPopup.open}
              onClose={onPortalClose.bind(this, 'otherPopup')}
              other={this.state.otherPopup.other}
              order={this.state.order}
              onSuccess={onPortalClose.bind(this, 'otherPopup')}
              saveOrder={this.props.saveOrder} />
          )
        }
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    activeEmployees: state.assign.activeEmployees,
    order: state.orders.order,
    hasPartner: state.auth.hasPartner
  }
}

export default connect(mapStateToProps, {
  getOrderInspection,
  saveOrderInspection,
  triggerPopup,
  getNextDeliveryTimes,
  GetDeliveryChange,
  getDeliveryTimes,
  getPickupTimes,
  getOrder,
  setOrder,
  saveOrder,
  getOrderData,
  isFileReady,
  uploadFileToOrder,
  deleteFileFromOrder,
  StopLockOrder,
  GetAssessmentItemsInOrderInspection,
  invoiceHistory,
  getInvoiceStatus,
  approveOrderInvoice,
  setPageTitle,
  getStandardNotes,
  getInsuranceCompanies,
  setLastVisitedOrderId
})(OrderInspection)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderInspection/index.js